import { cloneDeep } from 'lodash';

import { CommunicationTask } from '../../generic/communication-task/communication-task';
import { CommunicationTaskSchema } from '../../generic/communication-task/communication-task-schema';
import { CommunicationTaskName } from '../../generic/communication-task-name';

import { CommunicationTaskCallConstructor } from './communication-task-call-constructor';
import { CommunicationTaskCallSchema } from './communication-task-call-schema';

export class CommunicationTaskCall extends CommunicationTask {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected callSid!: string;

  protected callListId!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationTaskCallConstructor) {
    super(
      Object.assign(parameters, {
        [CommunicationTaskSchema.type]: CommunicationTaskName.call,
      }),
    );
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: import('joi').ValidationResult): CommunicationTaskCall {
    return new CommunicationTaskCall(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationTaskCall.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): CommunicationTaskCallSchema {
    return new CommunicationTaskCallSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getCallSid(): string {
    return cloneDeep(this.callSid);
  }

  public getCallListId(): string {
    return cloneDeep(this.callListId);
  }
}
